/**
 * Applies the clinic's brand colours across the platform by setting CSS custom
 * properties on :root (the design's components read `--primary-color` /
 * `--secondary-color`), so an admin's branding changes are reflected app-wide.
 */
export function applyBranding({ primaryColor, secondaryColor } = {}) {
  const root = document.documentElement;
  if (primaryColor) {
    root.style.setProperty('--primary-color', primaryColor);
    root.style.setProperty('--brand-primary', primaryColor);
  }
  if (secondaryColor) {
    root.style.setProperty('--secondary-color', secondaryColor);
    root.style.setProperty('--brand-secondary', secondaryColor);
  }
}

export default applyBranding;
